<button
  class="btn btn-reset btn-generate-ai"
  [class.loading]="loading"
  [class.ready]="ready"
  [class.isDisabled]="isDisabled"
  [disabled]="loading"
  [disableTooltip]="ready"
  ngbTooltip="{{ tooltipMessage }}"
  (click)="handleButtonClick()">
  <div class="loading-stars">
    <img src="/assets/star-lg.svg" class="star-lg" alt="Ai Stars" />
    <img src="/assets/star-sm.svg" class="star-sm" alt="Ai Stars" />
  </div>
  <img src="/assets/ai-stars.svg" class="ai-stars" alt="Ai Stars" />
  <span class="text"
    ><ng-container *ngIf="loading; else noData"
      ><span class="thinking"
        >Gathering Feedback<span class="ellipsis-anim ms-1"
          ><span>.</span><span>.</span><span>.</span></span
        ></span
      ></ng-container
    ><ng-template #noData>Get Smart Feedback</ng-template></span
  >
</button>
